export default __webpack_public_path__ + "media/images/tenant/hero_2-ac505d624fb0934e42ef2735adc990b0.jpg";